/*
 * Variables
 */
var $q = document.querySelector.bind(document),
    $qAll = document.querySelectorAll.bind(document);


/*
 * Window onload
 */
// addLoadEvent(function () {
//     jQuery('img.svg').each(function(){
//         var $img        = jQuery(this)
//             ,imgID      = $img.attr('id')
//             ,imgClass   = $img.attr('class')
//             ,imgURL     = $img.attr('src');


//         jQuery.get(imgURL, function(data) {

//             var $svg = jQuery(data).find('svg');
//             if(typeof imgID !== 'undefined') {
//                 $svg = $svg.attr('id', imgID);
//             }
//             if(typeof imgClass !== 'undefined') {
//                 $svg = $svg.attr('class', imgClass+' replaced-svg');
//             }

//             $svg = $svg.removeAttr('xmlns:a');
//             $svg.width("100%");
//             $svg.height("100%");
//             $svg.removeAttr("width");
//             $svg.removeAttr("height");
//             $img.replaceWith($svg);

//         }, 'xml');
//     });
// });

addLoadEvent(function () {

    var urlPath = window.location.pathname,
        divHref = urlPath.replace('/', '#');

    if ('/' != urlPath) {
        setTimeout(function () {
            scrollToPage(urlPath.replace('/', ''), $(divHref).data('title'));
        }, 500);
    }


    $('[href=#]').click(function (e) {
        e.preventDefault();
    });
    $('.fancybox').fancybox({
        padding: 0,
        margin: 50
    });
    if (!isMobile.any) {
        $('.fancybox-iframe').fancybox({
            width: "100%",
            type: 'iframe',
            padding: 0,
            margin: 50
        });
    }
});
window.addEventListener('DOMContentLoaded', function () {
    new QueryLoader2(document.querySelector("body"), {
        backgroundColor: "#fff",
        barColor: "#000"
    });
    $q('#body').style.opacity = 1;
});


/*
 * Big Banner
 */
function bigBannerResize() {
    var height = window.innerHeight - outerHeight($q('.navbar-header'));
    var banners = $qAll('.big-banner__item');

    for (var i = 0; i < banners.length; i++) {
        banners[i].style.height = height + 'px';
    }

    $q('.big-banner').style.height = height + 'px';
    $q('.big-banner').style.marginTop = outerHeight($q('.navbar-header')) + 'px';
}
if(isElement($q('.big-banner'))){
    addLoadEvent(bigBannerResize);
    $(window).smartResize(bigBannerResize);
}


function bigBannerParallax() {
    var banner = $qAll('.big-banner__item'),
        imageW = 1920,
        imageH = 930,
        bannerW = window.innerWidth,
        bannerH = window.innerHeight,
        propH = Math.round(imageH * bannerW / imageW),
        diffH = (propH - bannerH > 0) ? (propH - bannerH) : 0;

    var yPos = (window.pageYOffset / 2) - diffH;

    var coords = '50%   ' + yPos + 'px';

    for (var i = 0; i < banner.length; i++) {
        banner[i].style.backgroundPosition = coords;
    }
}
if (!isMobile.any && isElement($q('.big-banner'))) {
    addLoadEvent(bigBannerParallax);
    $(window).smartResize(bigBannerParallax);
    addScrollEvent(bigBannerParallax);
}

/*
 * Navbar
 */
$('body').scrollspy({target: '#navbar', offset: $('.navbar-header').height()});

$('#navbar a').bind('click', function (e) {
    e.preventDefault();
    var destino = this.getAttribute('href').replace('#', ''),
        href = this.getAttribute('href');

    $("#navbar li").removeClass('active');
    $(this).parent().addClass('active');

    scrollToPage(destino, this.getAttribute('title'));

    if (isMobile.any) {
        $('.navbar-toggle').click();
    }
});


/*
 * Páginas
 */
function startPageParallax() {
    if (window.innerWidth > 768) {
        var parallaxes = $qAll('.parallax-background');

        for (var i = 0; i < parallaxes.length; i++) {
            $('.parallax .bg' + (i + 1)).parallax("right", 0.6);
        }
    }
}

if (!isMobile.any) {
    addLoadEvent(function () {
        setTimeout(startPageParallax, 1000);
    });
    $(window).smartResize(startPageParallax);
}


/*
 * Isopote
 */
var $container = $('.isotope-wrap');
$container.isotope({
    itemSelector: '.isotope-item',
    animationEngine: 'best-available',
    animationOptions: {
        duration: 200,
        queue: false
    },
    layoutMode: 'fitRows'
});

function splitIsotopeColumns() {
    var winWidth = $container.width(),
        columnNumb = 1;

    if (winWidth > 1600) {
        columnNumb = 5;
    } else if (winWidth > 1200) {
        columnNumb = 4;
    } else if (winWidth > 900) {
        columnNumb = 3;
    } else if (winWidth > 600) {
        columnNumb = 2;
    } else if (winWidth > 300) {
        columnNumb = 1;
    }

    return columnNumb;
}

function setIsopoteColumns() {
    var winWidth = $container.width(),
        columnNumb = splitIsotopeColumns(),
        postWidth = Math.floor(winWidth / columnNumb);

    $container.find('.isotope-item').each(function () {
        $(this).find('img').css({
            width: postWidth + 'px'
        });
    });
}

function reLayoutIsotope() {
    setIsopoteColumns();
    $container.isotope('reLayout');
}

$container.imagesLoaded(reLayoutIsotope);
addLoadEvent(reLayoutIsotope);
$(window).smartResize(reLayoutIsotope);


/* ------------------------------------------------------------------------ */
/* BACK TO TOP
 /* ------------------------------------------------------------------------ */
$(window).scroll(function () {
    if (window.pageYOffset > 200) {
        $("#back-to-top").fadeIn(200);
    } else {
        $("#back-to-top").fadeOut(200);
    }
});
$('.back-to-top').click(function () {
    $("html, body").animate({scrollTop: 0}, {duration: 1200, easing: "easeInOutExpo"});
    history.pushState('/', '', '/');
    return false;
});


$(document.formContato).submit(function (event) {
    var lang = lang || null;
    theForm = $(this);

    var nome = $(theForm).find("#nome").val(),
        email = $(theForm).find("#email").val(),
        telefone = $(theForm).find("#telefone").val(),
        mensagem = $(theForm).find("#mensagem").val(),
        boletim = $(theForm).find("#boletim").is(':checked')

    $("input").removeClass("alert-danger");
    $(".submit-status").fadeOut('fast');
    $(".submit-status").html("");

    var FormData = true;

    if (nome === "") {
        $(theForm).find("#nome").addClass('alert-danger');
        FormData = false;
    }
    if (email === "") {
        $(theForm).find("#email").addClass('alert-danger');
        FormData = false;
    }
    if (!isValidEmail(email)) {
        $(theForm).find("#email").addClass('alert-danger');
        FormData = false;
    }
    if (mensagem === "") {
        $(theForm).find("#mensagem").addClass('alert-danger');
        FormData = false;
    }

    if (!FormData) {
        $(".submit-status").html("Ocorreu um erro ao enviar a mensagem!");
        $(".submit-status").fadeIn('fast');
    } else {

        jQuery.ajax({
            url: '/site/includes/contato-exe.php',
            type: 'POST',
            dataType: 'html',
            data: {
                nome: nome,
                email: email,
                telefone: telefone,
                mensagem: mensagem,
                boletim: (boletim) ? '1' : '0'
            },
            complete: function (xhr, textStatus) {
                //called when complete
            },
            success: function (data, textStatus, xhr) {

                //called when successful
                // $(theForm).find("#form-contato-preloader").slideUp(500, function() {
                //     $(theForm).find("#form-contato-submit").slideDown(200);
                // });

                setTimeout(function () {
                    $(theForm).find("#nome").val('');
                    $(theForm).find("#email").val('');
                    $(theForm).find("#telefone").val('');
                    $(theForm).find("#mensagem").val('');

                    if (lang == 'en') {
                        msgRtrn = "Message sent successfully!";
                    } else {
                        msgRtrn = "Mensagem enviada com sucesso!";
                    }

                    $(".submit-status").html(msgRtrn);

                    $(".submit-status").fadeIn(1000, function () {
                        setTimeout(function () {
                            $(".submit-status").fadeOut(1000);
                        }, 4000);
                    });
                }, 500);
            },
            error: function (xhr, textStatus, errorThrown) {
                setTimeout(function () {
                    msgRtrn = "Ocorreu um erro ao enviar a mensagem!";
                    $(".submit-status").slideDown(1000);
                }, 500);
            }
        });
    }

    event.preventDefault();

    return false;
});